import * as React from "react";
import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { InfoIcon } from "../InfoIcon/InfoIcon";

interface Props {
  label: string | React.ReactNode;
  value?: string | React.ReactNode;
  verticalAlignment?: "top" | "bottom" | "center";
  info?: string;
}

const LabelValue: React.FC<Props> = ({ label, value, verticalAlignment = "center", info }) => (
  <Stack alignItems={verticalAlignment} flexWrap="wrap" direction="row" spacing={1}>
    <Typography sx={theme => ({ color: theme.palette.grey["700"], fontWeight: 600 })}>{label}:</Typography>
    {info && <InfoIcon tooltip={info} />}
    <Box sx={{ flexGrow: 1 }}>{value}</Box>
  </Stack>
);

export { LabelValue };
